import { render, staticRenderFns } from "./PassivePopup.vue?vue&type=template&id=6570199a&"
import script from "./PassivePopup.vue?vue&type=script&lang=ts&"
export * from "./PassivePopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports